import { BasePageComponent } from '../../base/component/BasePageComponent';
import { BaseEntity, BaseState } from '../../base/entities/BaseEntities';
import { EnumPageDisplayModes } from '../framework/sysenums.enum';
import DxDataGrid from 'devextreme/ui/data_grid';

export class GridHelper {

    public static RefreshGridHeight(grid: DxDataGrid, page?: BasePageComponent<BaseEntity, BaseState>) {
        if (grid && this.GetRowCount(grid) > 0 && grid.option('dataSource') && !(grid as any)._disposed) {
            const height = this.GetGridHeightRelativeToPage(grid, page);
            const currentHeight = grid.option('height');
            if (height !== currentHeight) grid.option('height', height);
        }
    }

    public static GetGridHeightRelativeToPage(grid: DxDataGrid, page?: BasePageComponent<BaseEntity, BaseState>): any {
        const gridRect = grid.element().getBoundingClientRect();
        // If grid is empty there is no need to fit the full screen height
        if (this.GetRowCount(grid) === 0) return 'auto';

        // Calculate grid height fit to the page
        let height = window.innerHeight - gridRect.top;
        if (page && (page.DisplayMode === EnumPageDisplayModes.Window || page.DisplayMode === EnumPageDisplayModes.Dialog)) {
            const bottom = document.querySelector('.m4u-popup .page-body.dx-scrollview')?.getBoundingClientRect()?.bottom || 0;
            const bottomIndent = window.innerHeight - bottom;
            height -= bottomIndent;
        } else {
            // Get page footer height
            const pageFooters = document.querySelectorAll('.page-container m4u-footer');
            const pageFooter = pageFooters[pageFooters.length - 1];
            const pageFooterHeight = pageFooter && pageFooter['offsetParent'] 
                && (pageFooter['offsetParent'].offsetHeight - pageFooter['offsetTop']) || 0;
            height -= pageFooterHeight;
        }

        // Get layout padding
        const pageContainers = document.getElementsByClassName('page-body');
        if (!pageContainers || !pageContainers.length) return 'auto';

        const currentLayoutPadding = +(document?.defaultView
            ?.getComputedStyle(pageContainers[pageContainers.length - 1], '')
            ?.getPropertyValue('padding-bottom')?.match(/\d/g)?.join('') || 0);
        // If less than header and one row add window height
        return (height < 160 ? height + window.innerHeight : height) - currentLayoutPadding; // Layout padding, page footer
    }

    private static GetRowCount(grid: DxDataGrid): number {
        const iCount: number = grid.totalCount();
        return iCount == -1 ? grid.getVisibleRows().length : iCount;
    }
}